import { isValidElement, useEffect, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import { useFormDetailsActions } from "../../context/FormDetailsContext";
import { useNavigate } from "../../hooks";
import Subtotal from "./Subtotal";

import { useFormContext, useFormState } from "react-hook-form";

const Footer = ({ list, type = "order_form" }) => {
  const history = useHistory();
  const { isSubmitting } = useFormState();
  const { setFooterHeight } = useFormDetailsActions();
  const { getValues, resetField } = useFormContext();

  const ref = useRef();
  const { pathname } = useLocation();
  const pathIndex = list.indexOf(pathname);
  const last = pathIndex + 1 === list.length;
  let state;
  let next = list[pathIndex + 1];
  let back = type === "order_form" ? () => history.goBack() : false;
  let backText = "Back";
  let forwardText = "Next";
  let force = false;
  let disabled = false;
  switch (pathname) {
    case "/stock-photos":
      next = "/photos";
      forwardText = "Add";
      backText = "Cancel";
      disabled = !getValues("stock_photos").length;
      back = () => {
        resetField("stock_photos");
        history.goBack();
      };
      break;
    case "/new-order":
      next = "/photos";
      back = false;
      break;
    case "/signup":
      back = () => history.push(next, { isRealtor: true });
      state = { isRealtor: false };
      backText = "Yes";
      forwardText = "No";
      force = true;
      break;
    default:
      break;
  }
  useEffect(() => {
    if (ref.current) {
      setFooterHeight({ [type]: ref.current.clientHeight });
    }
  }, [ref, type, setFooterHeight]);
  const { handleNavigate } = useNavigate(type);
  const customButton = (button) => isValidElement(button) && button;
  const goBack = () => {
    handleNavigate(() => back(), force);
  };
  const goForward = () => {
    handleNavigate(() => history.push(next, state), force);
  };
  const forwardButton =
    customButton(next) ||
    (next && (
      <Button
        size="lg"
        onClick={goForward}
        type="button"
        block
        disabled={disabled}
      >
        {forwardText}
      </Button>
    ));
  const backButton =
    customButton(back) ||
    (back && (
      <Button size="lg" onClick={goBack} variant="outline-secondary" block>
        {backText}
      </Button>
    ));
  return (
    <div className="footer" ref={ref}>
      {type === "order_form" && <Subtotal />}
      <Row>
        {backButton && <Col>{backButton}</Col>}
        {forwardButton && <Col>{forwardButton}</Col>}
        {last && (
          <Col>
            <Button
              size="lg"
              type="submit"
              // disabled={
              //   (type === "order_form" && (!user || isSubmitting)) ||
              //   (type === "signup_form" && !charge_type)
              // }
              block
            >
              {type === "order_form"
                ? isSubmitting
                  ? "Submitting..."
                  : "Submit"
                : "Sign Up"}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default Footer;
